// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dppptcbparmacmlpdqbn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRwcHB0Y2JwYXJtYWNtbHBkcWJuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY2OTEyNDEsImV4cCI6MjA2MjI2NzI0MX0.XMxS24vzMp0BLcRm6-i_WtELG44epshmPb6Cf4G8EW4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);